import React, { useEffect, useState } from 'react';
import logoimg from '../../assets/MK1.3.png';
import senddata from "../../Data/data.js";
import sendFormData from "../../Data/formData.js";

function Messages() {
  const [comments, setComments] = useState([]);
  const [showRply, setShowRply] = useState(false);
  const [currentReply, setCurrentReply] = useState("");
  const [replymessage, setReplymessage] = useState("");

  // التسجيل الصوتي
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [currentCommentId, setCurrentCommentId] = useState(null); // لتخزين ID التعليق المرتبط بالتسجيل

  useEffect(() => {
    getAllComments();
  }, []);

  const getAllComments = () => {
    senddata("chat/show_comments_for_teacher", {}, "GET").then((res) => {
      if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
      } else {
        setComments(res.data);
        setShowRply(false);
      }
    });
  };

  const deleteComment = (comment) => {
    const userResponse = prompt(`اكتب ok لتأكيد حذف الرد `);
    if (userResponse?.trim() === "ok") {
      senddata(`chat/reply_on_comment/${comment._id}`, { reply: "" }, "put").then((res) => {
        if (res.status !== 200) {
          alert('تأكد من الاتصال من الانترنت ');
        } else {
          getAllComments();
          setReplymessage("");
        }
      });
    } else {
      alert("لم يتم حذف ألرد");
    }
  };

  const reply = (comment) => {
    senddata(`chat/reply_on_comment/${comment._id}`, { reply: replymessage }, "put").then((res) => {
      if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
      } else {
        getAllComments();
        setReplymessage("");
      }
    });
  };

  // ✅ التسجيل ورفع الصوت
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const chunks = [];
      const recorder = new MediaRecorder(stream);

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          chunks.push(e.data);
        }
      };

      recorder.onstop = async () => {
        const audioBlob = new Blob(chunks, { type: 'audio/webm' });

        if (audioBlob.size === 0) {
          alert("❌ لم يتم تسجيل أي صوت.");
          return;
        }

        const formData = new FormData();
        formData.append("file", audioBlob, "reply_audio.webm");

        console.log("📤 ملف الصوت:", formData.get("file"));

        const res = await sendFormData(`chat/upload_audio/${currentCommentId}`, formData, "post");

        if (res?.status === 200) {
          alert("✅ تم رفع الرد الصوتي");
          getAllComments();
        } else {
          alert("❌ فشل في رفع الرد الصوتي");
        }
        setAudioChunks([]);
        setMediaRecorder(null);
        stream.getTracks().forEach(track => track.stop());
      };

      recorder.start();
      setMediaRecorder(recorder);
      setAudioChunks(chunks);
      setIsRecording(true);

      // ⏹️ التسجيل يتوقف تلقائياً بعد 5 ثواني
      // setTimeout(() => {
      //   if (recorder.state !== "inactive") {
      //     recorder.stop();
      //     setIsRecording(false);
      //   }
      // }, 5000);

    } catch (err) {
      console.error("❌ فشل في بدء التسجيل:", err);
      alert("فشل في الوصول للمايكروفون");
    }
  };

  return (
    <div className='bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      <div className='headers'>
        <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto' />
      </div>

      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 w-[70%] ml-[15%] '>
        {comments?.length &&
          <div className='mt-10'>
            {comments.map((comment, key) => (
              <div key={key} className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2'>
                <div className="grid grid-cols-1 rever gap-4">
                  <p className='text-center text-[#e9ad03]'>{key + 1}</p>
                  <p dir='rtl'>👈 {comment.message}</p>
                  {comment.reply && <p dir='rtl'>💬 {comment.reply}</p>}
                  {comment.replyUrl && (
                    <audio controls className='w-full mt-2'>
                      <source src={comment.replyUrl} type="audio/webm" />
                      متصفحك لا يدعم تشغيل الصوت.
                    </audio>
                  )}
                  {showRply && (currentReply === key) && (
                    <>
                      <textarea
                        dir='rtl'
                        placeholder='اضف الرد النصي'
                        className='w-[90%] ml-[5%] rounded-xl text-black p-2'
                        value={replymessage}
                        onChange={(e) => setReplymessage(e.target.value)}
                      />
                      <div className='mt-2'>
                        {!isRecording ? (
                          <button
                            onClick={!isRecording ? startRecording : null}
                            className='bg-green-600 px-3 py-1 rounded'
                            disabled={isRecording}
                          >
                            🎤 بدء التسجيل
                          </button>
                        ) : (
                          <>
                            <button disabled className='bg-red-600 px-3 py-1 rounded'>
                              ⏳ جاري التسجيل...
                            </button>
                            <button
                              onClick={() => {
                                if (mediaRecorder && mediaRecorder.state === "recording") {
                                  mediaRecorder.stop();
                                  setIsRecording(false);
                                }
                              }}
                              className='bg-yellow-500 px-3 py-1 rounded mt-2'
                            >
                              ⏹️ إيقاف التسجيل
                            </button>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className='p-3'>
                  <div className='flex justify-between items-center'>
                    <div className='flex'>
                      <p onClick={() => deleteComment(comment)} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                      {showRply && currentReply === key && <p onClick={() => reply(comment)} className='mr-4 text-lg cursor-pointer'>👍</p>}
                      <p
                        onClick={() => {
                          setShowRply(!showRply);
                          setCurrentReply(key);
                          setCurrentCommentId(comment._id); // ✅ تحديد ID التعليق الحالي للتسجيل
                        }}
                        className='mr-4 text-lg cursor-pointer'
                      >
                        {showRply && currentReply === key ? "❌" : (comment.reply ? "✏️" : "💬")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  );
}

export default Messages;
